<div @show class="body">

    <div class="hint">
        <mat-icon class="icon">
            info
        </mat-icon>
        <div class="text-wrapper">
            Durch Ausführen der Transaktion werden mehrere Änderungen nacheinander ausgeführt. 
            Im Folgenden werden die dabei vorgenommenen Schritte aufgelistet. 
            Außerdem erhalten Sie auf dieser Seite Informationen zum aktuellen Fortschritt der jeweiligen Aktion.
        </div>
    </div>

    <div class="dynamic-content-wrapper">

        <ng-container #dynamicInner></ng-container>
        
    </div>

</div>